import React from 'react';
import { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import AppConst from "../apis/appconst";
import axios from "axios";
import { toast } from 'react-toastify';
import DataTable from 'react-data-table-component';
import Swal from "sweetalert2";

function Purchases() {
    const navigate = useNavigate();
    const [expandedRows, setExpandedRows] = useState([]);
    const [isAdmin, setIsAdmin] = useState(false);
    const [ldata, setLdata] = useState(null);

    // Payment Modal State
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedPurchase, setSelectedPurchase] = useState(null);
    const [paymentAmount, setPaymentAmount] = useState("");

    const [formData, setFormData] = useState({
        l1: [],
        purchase_type: 'normal',
        page_no: 0,
        search_key: '',
        from_date: new Date().toISOString().split('T')[0], // Current date
        to_date: new Date().toISOString().split('T')[0]     // Current date
    });

    const [totals, setTotals] = useState({
        totalAmount: 0,
        paidAmount: 0,
        dueAmount: 0,
        totalTaxCharges: 0,
    });
    const isAdminUser = () => {
        try {
          const raw = sessionStorage.getItem('ldata');
          if (!raw) return false;
          const user = JSON.parse(raw);
          return String(user?.role_id) === '1';
        } catch (e) {
          return false;
        }
      };
const isWithin24Hours = (purchaseDatetime) => {
  if (!purchaseDatetime) return false;

  // handle "YYYY-MM-DD HH:MM:SS"
  const created = new Date(purchaseDatetime.replace(' ', 'T'));
  if (isNaN(created)) return false;

  const HOURS_24 = 24 * 60 * 60 * 1000;
  return (Date.now() - created.getTime()) <= HOURS_24;
};
      
    const initData = async () => {
        const storedData = sessionStorage.getItem("ldata");
        const userData = JSON.parse(sessionStorage.getItem("ldata"));
        const roleId = userData?.role_id;
        
        if (roleId === 1 || roleId === "1") {
            setIsAdmin(true);
        } else {
            setIsAdmin(false);
        }

        if (storedData) {
            const fd = new FormData();
            fd.append('page_no', formData.page_no + "");
            fd.append('search_key', formData.search_key + "");
            // REMOVED: fd.append('purchase_user', 1 + ""); // No user filter
            fd.append('purchase_type', formData.purchase_type);
            fd.append('from_date', formData.from_date + "");
            fd.append('to_date', formData.to_date + "");

            try {
                const response = await axios.post(AppConst.BASE_URL + AppConst.getPurchaseListUrl, fd, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                if (response.data.status) {
                    var records = response.data.records;
                    if (records != null && records != undefined) {
                        setFormData(prev => ({
                            ...prev,
                            l1: records
                        }));
                    }
                }
            } catch (error) {
                console.error(error);
            }
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleClearFilters = () => {
        const today = new Date().toISOString().split('T')[0];
        setFormData(prev => ({
            ...prev,
            search_key: "",
            from_date: today,
            to_date: today,
        }));
    };

    const delItem = async (item) => {

        // 🔒 ADMIN CHECK (frontend safety)
        if (!isAdmin) {
            toast.error("Only admin can delete purchases");
            return;
        }
    
        const result = await Swal.fire({
            title: "Delete Purchase?",
            text: "This action cannot be undone!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it",
            cancelButtonText: "Cancel"
        });
    
        if (!result.isConfirmed) return;
    
        const fd = new FormData();
        fd.append("purchase_id", item.purchase_id);
    
        try {
            const response = await axios.post(
                AppConst.BASE_URL + AppConst.delPurchaseUrl,
                fd
            );
    
            if (response.data.status) {
                toast.success("Purchase deleted successfully");
                initData(); // reload list
            } else {
                toast.error(response.data.message || "Delete failed");
            }
        } catch (error) {
            toast.error("Failed to delete purchase");
            console.error(error);
        }
    };
    

    const canEdit = (purchaseDate) => {
        if (isAdmin) return true;
        
        const purchase = new Date(purchaseDate);
        const now = new Date();
        const diffInHours = (now - purchase) / (1000 * 60 * 60);
        
        return diffInHours <= 24;
    };

    // Payment Modal Handlers
    const handleOpenModal = (item) => {
        setSelectedPurchase(item);
        setPaymentAmount("");
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setSelectedPurchase(null);
    };

    const handlePaymentSubmit = async (e) => {
        e.preventDefault();
        
        const payValue = parseFloat(paymentAmount);
        const dueValue = parseFloat(selectedPurchase.purchase_due);

        if (isNaN(payValue) || payValue <= 0) {
            toast.error("Please enter a valid payment amount.");
            return;
        }

        if (payValue > dueValue) {
            toast.error(`Payment amount cannot be more than the due amount of ${dueValue}.`);
            return;
        }

        const fd = new FormData();
        fd.append('purchase_id', selectedPurchase.purchase_id);
        fd.append('paid_amount', payValue);
        
        try {
            const response = await axios.post(AppConst.BASE_URL + AppConst.makePurchasePaymentUrl, fd);

            if (response.data.status) {
                toast.success("Payment updated successfully!");
                handleCloseModal();
                initData();
            } else {
                toast.error(response.data.message || "Failed to update payment.");
            }
        } catch (error) {
            toast.error("An error occurred while processing the payment.");
            console.error("Payment submission error:", error);
        }
    };

    useEffect(() => {
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            setLdata(parsed);
            initData();
        }
    }, []);

    // Auto-reload when dates change
    useEffect(() => {
        if (formData.from_date && formData.to_date) {
            initData();
        }
    }, [formData.from_date, formData.to_date]);

    // Calculate totals
    useEffect(() => {
        let totalAmount = 0,
            paidAmount = 0,
            dueAmount = 0,
            totalTaxCharges = 0;

        const toNum = (val) => {
            const num = parseFloat(val);
            return isNaN(num) ? 0 : num;
        };

        formData.l1.forEach((purchase) => {
            totalAmount += toNum(purchase.purchase_total);
            paidAmount += toNum(purchase.purchase_paid);
            dueAmount += toNum(purchase.purchase_due);

            if (purchase.items && purchase.items.length > 0) {
                purchase.items.forEach((med) => {
                    totalTaxCharges += toNum(med.purchase_item_gst_value);
                });
            }
        });

        setTotals({
            totalAmount,
            paidAmount,
            dueAmount,
            totalTaxCharges,
        });
    }, [formData.l1]);

    // Expandable Row Component with Search
    const ExpandedComponent = ({ data }) => {
        const [medicineSearch, setMedicineSearch] = useState('');
        
        // Filter medicines based on search
        const filteredMedicines = data.items?.filter(med => 
            med.purchase_item_medicine?.toLowerCase().includes(medicineSearch.toLowerCase()) ||
            med.purchase_item_batch?.toLowerCase().includes(medicineSearch.toLowerCase())
        ) || [];
        
        return (
            <div className="p-3" style={{ backgroundColor: '#f8f9fa' }}>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h6 className="mb-0">Purchase Details - Invoice: {data.purchase_invoice}</h6>
                    <div className="d-flex align-items-center gap-2">
                        <input 
                            type="text"
                            className="form-control form-control-sm"
                            placeholder="Search medicine or batch..."
                            value={medicineSearch}
                            onChange={(e) => setMedicineSearch(e.target.value)}
                            style={{ width: '250px' }}
                        />
                        {medicineSearch && (
                            <button 
                                className="btn btn-sm btn-outline-secondary"
                                onClick={() => setMedicineSearch('')}
                            >
                                <i className="ri-close-line"></i>
                            </button>
                        )}
                        <span className="badge bg-info ms-2">
                            {filteredMedicines.length} / {data.items?.length || 0}
                        </span>
                    </div>
                </div>
                <div className="table-responsive">
                    <table className="table table-bordered table-sm">
                        <thead style={{ backgroundColor: '#e9ecef' }}>
                            <tr>
                                <th>Medicine</th>
                                <th>Qty</th>
                                <th>Free</th>
                                <th>Strips</th>
                                <th>Exp Date</th>
                                <th>Disc (%)</th>
                                <th>Tax Amt</th>
                                <th>Batch</th>
                                <th>MRP</th>
                                <th>Gross Value</th>
                                <th>Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredMedicines.length > 0 ? (
                                filteredMedicines.map((med, index) => (
                                    <tr key={index}>
                                        <td>{med.purchase_item_medicine}</td>
                                        <td>{med.purchase_item_qty}</td>
                                        <td>{med.purchase_item_free}</td>
                                        <td>{med.purchase_item_tab_cap}</td>
                                        <td>
                                            {med.purchase_item_expiry_month && med.purchase_item_expiry_year
                                                ? `${med.purchase_item_expiry_month}/${med.purchase_item_expiry_year}`
                                                : "-"}
                                        </td>
                                        <td>{med.purchase_item_discount}</td>
                                        <td>{med.purchase_item_gst_value}</td>
                                        <td>{med.purchase_item_batch}</td>
                                        <td>{med.purchase_item_pur_price}</td>
                                        <td>{med.purchase_item_gross_value}</td>
                                        <td>{med.purchase_item_gtotal}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="11" className="text-center py-3 text-muted">
                                        <i className="ri-search-line fs-4"></i>
                                        <p className="mb-0 mt-2">No medicines found matching "{medicineSearch}"</p>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    };

    // Format date to DD-MMM-YYYY (e.g., 12-Oct-2025)
    const formatDate = (dateString) => {
        if (!dateString) return '-';
        
        const date = new Date(dateString);
        const day = date.getDate().toString().padStart(2, '0');
        const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 
                           'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const month = monthNames[date.getMonth()];
        const year = date.getFullYear();
        
        return `${day}-${month}-${year}`;
    };

    // DataTable Columns
    const columns = [
        {
            name: 'Invoice',
            selector: row => row.purchase_invoice,
            sortable: true,
            width: '150px'
        },
        {
            name: 'Date',
            selector: row => row.purchase_date,
            sortable: true,
            width: '130px',
            cell: row => formatDate(row.purchase_date)
        },
        {
            name: 'Supplier',
            selector: row => row.purchase_supplier,
            sortable: true,
            grow: 2
        },
        {
            name: 'Total',
            selector: row => row.purchase_total,
            sortable: true,
            width: '120px',
            right: true,
            cell: row => `₹${parseFloat(row.purchase_total || 0).toFixed(2)}`
        },
        {
            name: 'Paid',
            selector: row => row.purchase_paid || 0,
            sortable: true,
            width: '120px',
            right: true,
            cell: row => `₹${parseFloat(row.purchase_paid || 0).toFixed(2)}`
        },
        {
            name: 'Due',
            selector: row => row.purchase_due,
            sortable: true,
            width: '120px',
            right: true,
            cell: row => `₹${parseFloat(row.purchase_due || 0).toFixed(2)}`
        },
        {
            name: 'Status',
            width: '120px',
            cell: row => {
                const total = parseFloat(row.purchase_total || 0);
                const paid = parseFloat(row.purchase_paid || 0);
                const due = parseFloat(row.purchase_due || 0);
                
                // Determine payment status
                let badgeClass = '';
                let badgeText = '';
                
                if (paid >= total || due <= 0) {
                    // Fully paid
                    badgeClass = 'badge bg-success';
                    badgeText = 'Paid';
                } else if (paid > 0 && paid < total) {
                    // Partial payment
                    badgeClass = 'badge bg-warning text-dark';
                    badgeText = 'Partial';
                } else {
                    // Not paid
                    badgeClass = 'badge bg-danger';
                    badgeText = 'Not Paid';
                }
                
                return <span className={badgeClass}>{badgeText}</span>;
            }
        },
        {
            name: 'Actions',
            width: '280px',
            cell: (row) => {
                const admin = isAdminUser();
                const editable = canEdit(row.purchase_datetime); // ✅ renamed
              
                return (
                  <div className="d-flex gap-2">
              
                    {/* PRINT */}
                    <button className="btn btn-sm btn-outline-info">
                      <i className="ri-printer-line"></i> Print
                    </button>
              
                    {/* PAY */}
                    {/* <button
                      className="btn btn-sm btn-outline-success"
                      onClick={() => handleOpenModal(row)}
                    >
                      <i className="ri-money-dollar-circle-line"></i> Pay
                    </button> */}
              
                    {/* EDIT */}
                    <button
                      className="btn btn-sm btn-outline-primary"
                      style={{
                        opacity: editable ? 1 : 0.5,
                        cursor: editable ? 'pointer' : 'not-allowed'
                      }}
                      onClick={() => {
                        if (!editable) {
                          const created = new Date(row.purchase_datetime.replace(" ", "T"));
                          const unlockAt = new Date(created.getTime() + 24 * 60 * 60 * 1000);
              
                          Swal.fire({
                            icon: 'info',
                            title: 'Edit Locked',
                            html: `
                              Purchase created at:<br>
                              <b>${created.toLocaleString()}</b><br><br>
                              Editing allowed only within <b>24 hours</b>.<br>
                              You can edit until:<br>
                              <b>${unlockAt.toLocaleString()}</b>
                            `
                          });
                          return;
                        }
              
                        sessionStorage.setItem("opd_dt", JSON.stringify(row));
                        navigate("/new_purchase");
                      }}
                    >
                      <i className="ri-pencil-line"></i>
                    </button>
              
                    {/* DELETE */}
                    <button
                      className="btn btn-sm btn-outline-danger"
                      style={{
                        opacity: admin ? 1 : 0.5,
                        cursor: admin ? 'pointer' : 'not-allowed'
                      }}
                      onClick={() => admin ? delItem(row) : Swal.fire("Only admin can delete")}
                    >
                      <i className="ri-delete-bin-line"></i>
                    </button>
              
                  </div>
                );
              },
              
            
            ignoreRowClick: true,
            allowOverflow: true,
            button: true
          }
    ];

    // Custom styles for DataTable
    const customStyles = {
        headRow: {
            style: {
                backgroundColor: '#405189',
                color: '#fff',
                fontSize: '14px',
                fontWeight: 'bold',
                borderRadius: '5px 5px 0 0'
            }
        },
        headCells: {
            style: {
                color: '#fff',
                paddingLeft: '16px',
                paddingRight: '16px'
            }
        },
        rows: {
            style: {
                fontSize: '14px',
                '&:hover': {
                    backgroundColor: '#f8f9fa',
                    cursor: 'pointer'
                }
            }
        }
    };

    return (
        <div className="page-content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card">
                            <div className="card-header border-0">
                                <div className="row align-items-center gy-3">
                                    <div className="col-sm">
                                        <h5 className="card-title mb-0">Purchases</h5>
                                    </div>
                                    <div className="col-sm-auto">
                                        <button 
                                            type="button" 
                                            className="btn btn-success"
                                            onClick={() => {
                                                sessionStorage.removeItem("opd_dt");
                                                navigate("/new_purchase");
                                            }}
                                        >
                                            <i className="ri-add-line align-bottom me-1"></i> Add Purchase
                                        </button>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="card-body border border-dashed border-end-0 border-start-0">
                                <div className="row g-3">
                                    <div className="col-md-3">
                                        <label className="form-label">From Date</label>
                                        <input 
                                            className="form-control" 
                                            type="date" 
                                            name="from_date"
                                            onChange={handleChange} 
                                            value={formData.from_date} 
                                        />
                                    </div>
                                    <div className="col-md-3">
                                        <label className="form-label">To Date</label>
                                        <input 
                                            className="form-control" 
                                            type="date" 
                                            name="to_date"
                                            onChange={handleChange} 
                                            value={formData.to_date} 
                                        />
                                    </div>
                                    <div className="col-md-2">
                                        <label className="form-label">&nbsp;</label>
                                        <div>
                                            <button 
                                                type="button" 
                                                onClick={handleClearFilters} 
                                                className="btn btn-info w-100"
                                            >
                                                <i className="ri-refresh-line me-1"></i> Clear
                                            </button>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <label className="form-label">Search</label>
                                        <input 
                                            className="form-control" 
                                            placeholder="Search by Invoice or Supplier..." 
                                            type="text"
                                            name="search_key" 
                                            onChange={handleChange} 
                                            value={formData.search_key} 
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="card-body pt-0">
                                <DataTable
                                    columns={columns}
                                    data={formData.l1}
                                    customStyles={customStyles}
                                    pagination
                                    paginationPerPage={10}
                                    paginationRowsPerPageOptions={[10, 25, 50, 100]}
                                    expandableRows
                                    expandableRowsComponent={ExpandedComponent}
                                    highlightOnHover
                                    pointerOnHover
                                    responsive
                                    striped
                                    noDataComponent={
                                        <div className="text-center py-5">
                                            <i className="ri-file-list-line fs-1 text-muted"></i>
                                            <p className="mt-3">No purchases found</p>
                                        </div>
                                    }
                                />
                                
                                <div className="mt-3 p-3 bg-light rounded">
                                    <div className="row text-center">
                                        <div className="col-md-3">
                                            <strong>Total Amount:</strong>
                                            <div className="fs-5 text-primary">₹ {totals.totalAmount.toFixed(2)}</div>
                                        </div>
                                        <div className="col-md-3">
                                            <strong>Paid Amount:</strong>
                                            <div className="fs-5 text-success">₹ {totals.paidAmount.toFixed(2)}</div>
                                        </div>
                                        <div className="col-md-3">
                                            <strong>Due Amount:</strong>
                                            <div className="fs-5 text-danger">₹ {totals.dueAmount.toFixed(2)}</div>
                                        </div>
                                        <div className="col-md-3">
                                            <strong>Total Tax:</strong>
                                            <div className="fs-5 text-info">₹ {totals.totalTaxCharges.toFixed(2)}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            {/* Payment Modal */}
            {isModalOpen && selectedPurchase && (
                <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header bg-primary text-white">
                                <h5 className="modal-title">
                                    <i className="ri-money-dollar-circle-line me-2"></i>
                                    Make Payment
                                </h5>
                                <button type="button" className="btn-close btn-close-white" onClick={handleCloseModal}></button>
                            </div>
                            <div className="modal-body">
                                <div className="mb-3">
                                    <h6>Invoice: <span className="text-primary">{selectedPurchase.purchase_invoice}</span></h6>
                                    <p className="text-muted mb-0">Supplier: {selectedPurchase.purchase_supplier}</p>
                                </div>
                                <hr/>
                                <form onSubmit={handlePaymentSubmit}>
                                    <div className="row g-3">
                                        <div className="col-md-6">
                                            <label className="form-label">Total Amount</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={`₹ ${selectedPurchase.purchase_total || ''}`} 
                                                readOnly 
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label">Paid So Far</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={`₹ ${selectedPurchase.purchase_paid || '0'}`} 
                                                readOnly 
                                            />
                                        </div>
                                        <div className="col-md-12">
                                            <label className="form-label fw-bold text-danger">Amount Due</label>
                                            <input 
                                                type="text" 
                                                className="form-control bg-light fw-bold fs-5" 
                                                value={`₹ ${selectedPurchase.purchase_due || ''}`} 
                                                readOnly 
                                            />
                                        </div>
                                        <hr className="my-3"/>
                                        <div className="col-md-12">
                                            <label htmlFor="paymentInput" className="form-label fw-bold">
                                                Pay Amount <span className="text-muted">(Max: ₹{selectedPurchase.purchase_due})</span>
                                            </label>
                                            <div className="input-group input-group-lg">
                                                <span className="input-group-text">₹</span>
                                                <input 
                                                    type="number" 
                                                    id="paymentInput"
                                                    className="form-control" 
                                                    placeholder="Enter payment amount"
                                                    value={paymentAmount}
                                                    onChange={(e) => setPaymentAmount(e.target.value)}
                                                    max={selectedPurchase.purchase_due}
                                                    step="0.01"
                                                    autoFocus
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>
                                    <i className="ri-close-line me-1"></i> Close
                                </button>
                                <button type="button" className="btn btn-success" onClick={handlePaymentSubmit}>
                                    <i className="ri-check-line me-1"></i> Pay
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Purchases;